<template>
  <div
    class="tw-fixed tw-flex tw-flex-col-reverse tw-items-start tw-right-4 tw-z-50"
    :style="{ top }"
  >
    <div
      v-for="(item, index) in activeToasts"
      :key="index"
      class="tw-w-80 tw-rounded tw-util-shadow-xl tw-px-5 tw-mb-4 tw-py-4 tw-overflow-hidden tw-relative game-modal-background-color game-modal-text-color"
    >
      <base-button
        v-if="item.hasClose"
        input-btn
        icon="times"
        icon-size="lg"
        class="tw-absolute tw-top-0 tw-right-0"
        @click.prevent="close(item.name)"
      >
      </base-button>

      <div
        class="tw-absolute tw-top-0 tw-left-0 tw-w-2 tw-h-full"
        :class="typeBgStyle(item)"
      />

      <div class="tw-flex tw-space-x-3">
        <font-awesome-icon
          :icon="typeIcon(item)"
          :class="typeTextStyle(item)"
          size="2x"
        />
        <div class="tw-space-y-1">
          <span v-if="item.title" class="tw-flex tw-font-bold">
            {{ item.title }}
          </span>
          <span v-if="item.text" class="tw-flex tw-text-xs">
            {{ item.text }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { containerScroll } from '@composables/useWindowEvents.js'
import { useToast } from '@composables'
import { computed } from 'vue'
export default {
  setup() {
    const { activeToasts, close } = useToast()

    const top = computed(() => {
      let _top = 0
      if (containerScroll.value?.frameTop < 0) {
        _top = -containerScroll.value.frameTop
      }
      return `calc(${_top}px + 5rem)`
    })

    function typeTextStyle(name) {
      if (name.isSuccess) {
        return 'tw-text-success'
      } else if (name.isWarning) {
        return 'tw-text-warning'
      } else if (name.isError) {
        return 'tw-text-danger'
      } else {
        return 'game-link-color'
      }
    }

    function typeIcon(name) {
      if (name.isSuccess) {
        return 'check-circle'
      } else if (name.isWarning) {
        return 'exclamation-circle'
      } else if (name.isError) {
        return 'times-circle'
      } else {
        return 'info-circle'
      }
    }

    function typeBgStyle(name) {
      if (name.isSuccess) {
        return 'tw-bg-success'
      } else if (name.isWarning) {
        return 'tw-bg-warning'
      } else if (name.isError) {
        return 'tw-bg-danger'
      } else {
        return 'game-primary-button-color'
      }
    }

    return {
      typeTextStyle,
      typeBgStyle,
      activeToasts,
      typeIcon,
      close,
      top,
    }
  },
}
</script>
